import api from './index';

export const apiSendTask = async (task) => {
  try {
    const { data } = await api.post(`/companies/${task.companyId}/tasks`, { task });
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetTasks = async (companyId, query) => {
  try {
    const { data } = await api.get(`/companies/${companyId}/tasks${query ? `?${query}` : ''}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetTaskDetail = async (companyId, taskId) => {
  try {
    const { data } = await api.get(`/companies/${companyId}/tasks/${taskId}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetTaskNfs = async (taskId) => {
  try {
    const { data } = await api.get(`/tasks/${taskId}/nfs`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetTaskPaymentTicket = async (taskId) => {
  try {
    const { data } = await api.get(`/tasks/${taskId}/payment-ticket`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetAddress = async (companyId, addressId) => {
  try {
    const { data } = await api.get(`/companies/${companyId}/addresses/${addressId}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetTasksFilters = async (url, companyId, term) => {
  try {
    const { data } = await api.get(`/companies/${companyId}/${url}${term ? `?term=${term}` : ''}`);
    return data[url];
  } catch (error) {
    throw error;
  }
};

export const apiHireTask = async (taskId, quoteId) => {
  try {
    const { data } = await api.post(`/tasks/${taskId}/hirings`, { quote_id: quoteId });
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiCancelQuoteTask = async (quoteId) => {
  try {
    const { data } = await api.patch(`/quote/${quoteId}/set-unselected`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetCancelTaskOptions = async (status) => {
  try {
    const { data } = await api.get(
      '/feedback?enabled=true&type=cancel_task_company',
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiCancelHiredTask = async (payload) => {
  const { task_id } = payload.task_problem;
  try {
    const { data } = await api.put(`/tasks/${task_id}/archive`, payload);
    return data;
  } catch (error) {
    throw error;
  }
};

export const getReportProblemReasonsApi = async () => {
  try {
    const { data } = await api.get('/feedback?enabled=true&type=company_task_problem');
    return data;
  } catch (error) {
    throw error;
  }
};

export const sendReportProblemApi = async (task_id, user_id, feedback) => {
  const { feedback_id, comments } = feedback;
  const taskProblem = {
    task_id,
    user_id,
    feedback_id,
    comments,
  };

  try {
    const { data } = await api.post(`/task/${task_id}/problem`, { taskProblem });
    return data;
  } catch (error) {
    throw error;
  }
};

export const getReportProblemsApi = async (task_id) => {
  try {
    const { data } = await api.get(`/tasks/${task_id}/problems`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiAddPhotoToTask = async (taskId, photo) => {
  const photoBody = {
    photo: {
      name: photo.name || '',
      height: photo.height || 500,
      task_id: taskId,
      url: photo.url,
      width: photo.width || 500,
    },
  };

  try {
    const data = await api.post('/task/add-photo', photoBody);
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiRemovePhotoFromTask = async (photoId) => {
  try {
    const data = await api.delete(`/task/delete-photo/${photoId}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiRatingTaskProfessionalRequest = async (payload) => {
  const { task_id } = payload;
  try {
    const data = await api.patch(`/task/${task_id}/rate`, { ...payload });
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiAuthorizeTask = async (payload) => {
  const { quoteId, success } = payload;
  try {
    const data = await api.patch(`/quote/${quoteId}/set-approved`, { success });
    return data;
    // return payload;
  } catch (error) {
    throw error;
  }
};

export const apiScheduling = async (payload) => {
  const {
    taskId, message, quoteId, scheduleDate,
  } = payload;
  try {
    const data = await api.post(`/tasks/${taskId}/set-schedule`, {
      scheduleDate,
      quoteId,
      message,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiCreatePaymentInfo = async (taskId, paymentInfo) => {
  try {
    return await api.post(`/payment/${taskId}/billing-info`, paymentInfo);
  } catch (error) {
    throw error;
  }
};

export const apiUpdatePaymentInfo = async (taskId, paymentInfo) => {
  try {
    return await api.put(`/payment/${taskId}/billing-info`, paymentInfo);
  } catch (error) {
    throw error;
  }
};

export const getStatusTabs = async (company_id) => {
  try {
    const { data } = await api.get(`/companies/${company_id}/status/tasks`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const getServicesByCompany = async (company_id) => {
  try {
    const { data } = await api.get(`/companies/${company_id}/services`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const getTasksByCompanyAndTab = async (company_id, tab, query) => {
  try {
    // tabs: 'open', 'hired', 'charged', 'finished'
    const { data } = await api.get(
      `/companies/${company_id}/tabs/${tab}/tasks${query ? `?${query}` : ''}`, { params: { limit: 10 } },
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const setTagNewQuote = async (company_id, task_id) => {
  try {
    const { data } = await api.put(`/companies/${company_id}/read/${task_id}/quote`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const setTagNewTask = async (company_id, task_id) => {
  try {
    const { data } = await api.put(`/companies/${company_id}/read/${task_id}/task`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const updateTaskVisited = async (task_id, isNeedVisit) => {
  try {
    const { data } = await api.put(`/task/${task_id}/task-visit`, { is_needed_visit: isNeedVisit });
    return data;
  } catch (error) {
    throw error;
  }
};

export const editTaskVisit = async (task_visit) => {
  try {
    const { data } = await api.put(`/task-visit/${task_visit.id}`, task_visit);
    return data;
  } catch (error) {
    throw error;
  }
};

export const createTaskVisit = async (task_visit) => {
  try {
    const { data } = await api.post('/task-visit', task_visit);
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteTaskVisit = async (id) => {
  try {
    const { data } = await api.delete(`/task-visit/${id}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetComments = async (taskId) => {
  try {
    const { data } = await api.get(
      `/tasks/${taskId}/activities`,
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const linkUserOperator = async (task_id, operator_id) => {
  try {
    const { data } = await api.put(`/task/${task_id}/link-operator`, { operator_id });
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiIncludeComment = async (taskId, comment) => {
  try {
    const { data } = await api.post(
      `/tasks/${taskId}/activities`, { ...comment },
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const unlinkUserOperator = async (task_id) => {
  try {
    const { data } = await api.put(`/task/${task_id}/unlink-operator`);
    return data;
  } catch (error) {
    throw error;
  }
};

export async function generateCheckoutLink(body) {
  try {
    const { data } = await api.post('/checkout/generate-link', body);
    return data;
  } catch (error) {
    throw error;
  }
}

export const setUserTaskAPI = async (company_id, task_id, user_id, source) => {
  try {
    const { data } = await api.patch(`/companies/${company_id}/tasks/${task_id}/set-user`, { user_id, source });
    return data;
  } catch (error) {
    throw error;
  }
};
